<div>
  @for (meddelandeInfotavla of systemaktivitetlista; track meddelandeInfotavla) {
    <div class="alert alert-warning alert-dismissible fade show" role="alert"
      >
      <button type="button" class="btn btn-icon" (click)="dismiss(meddelandeInfotavla)"
        style="vertical-align: inherit">
        <span class="far fa-times"></span>
      </button>
      {{ meddelandeInfotavla.rubrik }}
      &nbsp;<a [routerLink]="['/systemaktivitet']">{{texts.read}}</a>
    </div>
  }
</div>